module.exports = __webpack_public_path__ + "img/202.47d13e29.png";